<template>
    <div>
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="line"></div>
            <div class="page-title">我的采购</div>
            <el-button style="margin-left: auto;" type="primary" size="small"
                @click="handleAddPurchase">发布采购</el-button>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="采购单号" class="form-item-purchase-id">
                    <el-input v-model="searchForm.order_sn" placeholder="请输入" size="small"></el-input>
                </el-form-item>

                <!-- <el-form-item label="订单状态" class="form-item-status">
                    <el-select v-model="searchForm.status" placeholder="请选择" size="small">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="一轮比价" value="firstRoundComparison"></el-option>
                        <el-option label="一轮询价" value="firstRoundInquiry"></el-option>
                        <el-option label="二轮比价" value="secondRoundComparison"></el-option>
                        <el-option label="配载中" value="loading"></el-option>
                        <el-option label="待发货" value="pendingShipment"></el-option>
                        <el-option label="待收货" value="pendingReceipt"></el-option>
                        <el-option label="待结算" value="pendingSettlement"></el-option>
                        <el-option label="已完成" value="completed"></el-option>
                        <el-option label="已取消" value="cancelled"></el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item label="采购标题" class="form-item-title">
                    <el-input v-model="searchForm.title" placeholder="请输入" size="small"></el-input>
                </el-form-item>

                <el-form-item label="采购时间" class="form-item-date">
                    <el-date-picker v-model="searchForm.time" type="date" placeholder="请选择日期"
                        format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small"></el-date-picker>
                </el-form-item>

                <el-form-item class="form-item-reset">
                    <el-button type="default" size="small" @click="resetSearch">重置</el-button>
                </el-form-item>

                <el-form-item class="form-item-search">
                    <el-button type="primary" size="small" @click="searchPurchases">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 订单状态标签 -->
        <div class="status-tabs">
            <el-radio-group v-model="activeStatus" size="small" class="status-radio-group" @change="handleStatusChange">
                <el-radio-button label="0">全部</el-radio-button>
                <el-radio-button label="1">一轮比价</el-radio-button>
                <el-radio-button label="2">一轮询价</el-radio-button>
                <el-radio-button label="3">二轮比价</el-radio-button>
                <el-radio-button label="4">配载中</el-radio-button>
                <el-radio-button label="5">配载完成</el-radio-button>
                <el-radio-button label="6">运输中</el-radio-button>
                <el-radio-button label="7">待收货</el-radio-button>
                <el-radio-button label="8">待结算</el-radio-button>
                <el-radio-button label="9">已完成</el-radio-button>
                <el-radio-button label="-1">已取消</el-radio-button>
            </el-radio-group>
        </div>

        <!-- 采购表格 -->
        <el-table :data="purchaseData" :border="true" style="width: 100%" class="purchase-table">
            <!-- 采购单号列 -->
            <el-table-column prop="order_sn" label="采购单号" width="200">

            </el-table-column>

            <!-- 订单状态列 -->
            <el-table-column prop="status" label="订单状态" width="100">
                <template slot-scope="scope">
                    <span :class="getStatusClass(scope.row.status)">{{ scope.row.status_name }}</span>
                </template>
            </el-table-column>

            <!-- 采购标题列 -->
            <el-table-column prop="title" label="采购标题" min-width="250"></el-table-column>

            <!-- 结算周期列 -->
            <el-table-column prop="settle_type_name" label="结算周期" width="80"></el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                    <div class="action-buttons">
                        <!-- 根据不同状态显示不同操作按钮 -->
                        <template>
                            <el-button type="text" size="small" class="text-btn end-purchase"
                                v-if="scope.row.status == '1' || scope.row.status == '2' || scope.row.status == '3' || scope.row.status == '4'"
                                @click="handleCaigouOrder(scope.row)">结束采购</el-button>
                            <el-button type="text" size="small" class="text-btn edit-purchase"
                                v-if="scope.row.status == '1' || scope.row.status == '2' || scope.row.status == '3'"
                                @click="handleEditOrder(scope.row)">修改采购</el-button>
                            <el-button type="text" size="small" class="text-btn cancel-order"
                                v-if="scope.row.status == '-1'" @click="handleDeleteOrder(scope.row)">删除</el-button>
                            <el-button type="text" size="small" class="text-btn"
                                v-if="scope.row.status == '9' && scope.row.is_invoice == 0"
                                @click="applyInvoice(scope.row.aid)">申请开票</el-button>
                            <el-button type="text" size="small" class="text-btn view-details"
                                @click="handleViewDetails(scope.row)">查看详情</el-button>
                        </template>

                        <!-- <template v-else-if="scope.row.status === '配载中'">
                            <el-button type="text" size="small" class="text-btn edit-purchase">修改采购</el-button>
                            <el-button type="text" size="small" class="text-btn view-details">查看详情</el-button>
                        </template> -->

                        <!-- <template
                            v-else-if="scope.row.status === '待发货' || scope.row.status === '待收货' || scope.row.status === '待结算'">
                            <el-button type="text" size="small" class="text-btn view-details">查看详情</el-button>
                        </template> -->

                        <!-- <template v-else-if="scope.row.status === '已完成'">
                            <el-button type="text" size="small" class="text-btn apply-invoice">申请开票</el-button>
                            <el-button type="text" size="small" class="text-btn buy-again">再买一单</el-button>
                            <el-button type="text" size="small" class="text-btn view-details">查看详情</el-button>
                        </template> -->

                        <!-- <template v-else-if="scope.row.status === '已取消'">
                            <el-button type="text" size="small" class="text-btn cancel-order">取消订单</el-button>
                            <el-button type="text" size="small" class="text-btn view-details">查看详情</el-button>
                        </template> -->
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页控件 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PurchasesList',
    data() {
        return {
            searchForm: {
                order_sn: '',
                status: '',
                title: '',
                time: ''
            },
            activeStatus: '0',

            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,

            // 采购数据 - 模拟实际采购数据结构
            purchaseData: []
        }
    },
    mounted() {
        this.getMyPurchaseList();
    },
    methods: {
        handleAddPurchase() {
            this.$router.push({
                path: '/FabuCaigou',
            })
        },
        handleViewPurchase(purchase) {
            // 处理查看详情采购单逻辑
            this.$parent.currentComponent = 'PurchasesDetail';
            this.$parent.componentParams = { purchaseId: purchase.aid };
        },
        handleViewDetails(purchase) {
            // 处理查看详情逻辑
            this.$parent.currentComponent = 'PurchasesDetail';
            this.$parent.componentParams = { purchaseId: purchase.aid };
            console.log('查看采购单详情:', purchase)
            // 可以跳转到详情页或显示详情弹窗
            // this.$router.push({ name: 'PurchasesDetail', params: { id: purchase.id } })
        },

        // 处理结束采购订单
        handleCaigouOrder(order) {
            this.$confirm('确定要结束采购吗？', '结束采购', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.endPurchase(order.aid);
            }).catch(() => {
                this.$message.info('已取消');
            });
        },

        // 处理删除订单
        handleDeleteOrder(order) {
            this.$confirm('确定要删除此订单吗？', '删除订单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteOrder(order.aid);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        resetSearch() {
            this.searchForm = {
                order_sn: '',
                status: '',
                title: '',
                time: ['', '']
            }
            this.getMyPurchaseList();
        },
        searchPurchases() {
            // 实现搜索逻辑         
            this.getMyPurchaseList();
        },
        getStatusClass(status) {
            // 根据状态返回不同的样式类
            switch (status) {
                case '一轮比价':
                case '一轮询价':
                case '二轮比价':
                    return 'status-comparison';
                case '配载中':
                    return 'status-loading';
                case '待发货':
                    return 'status-pending-shipment';
                case '待收货':
                    return 'status-pending-receipt';
                case '待结算':
                    return 'status-pending-settlement';
                case '已完成':
                    return 'status-completed';
                case '已取消':
                    return 'status-cancelled';
                default:
                    return '';
            }
        },

        // 处理状态切换
        handleStatusChange(value) {
            this.activeStatus = value;
            this.getMyPurchaseList();
        },
        // 结束采购
        endPurchase(aid) {
            // console.log('结束采购');
            this.$dapi.endPurchase({
                aid: aid
            }).then(res => {
                this.$message.success('结束采购成功');
                // 返回列表页面
                // this.$parent.handleComponentChange('PurchasesList');
                this.getMyPurchaseList();
            }).catch(err => {
                this.$message.error('结束采购失败');
            });
        },

        // 删除订单
        deleteOrder(aid) {
            // console.log('删除订单');
            this.$dapi.deleteCaigouOrder({
                aid: aid
            }).then(res => {
                this.$message.success('删除订单成功');
                // 返回列表页面
                this.getMyPurchaseList()
            }).catch(err => {
                this.$message.error('删除订单失败');
            });
        },

        // 跳转修改采购页面
        handleEditOrder(order) {
            this.$router.push({
                path: 'FabuCaigou',
                query: {
                    aid: order.aid
                }
            });
        },

        // 申请开票
        applyInvoice(aid) {
            let data = {
                aid: aid
            }
            this.$api.applyInvoice(data).then(res => {
                this.$message.success('申请开票成功');
                this.getMyPurchaseDetail()
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取我的采购列表
        getMyPurchaseList() {
            this.$api.getMyPurchaseList({
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                status: this.activeStatus,
                order_sn: this.searchForm.order_sn,
                title: this.searchForm.title,
                date: this.searchForm.time || ''
            }).then(res => {
                this.purchaseData = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getMyPurchaseList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getMyPurchaseList();
        },

    }
}
</script>

<style scoped>
/* 基础容器样式 */
.my-purchases-container {
    background-color: #fff;
    border-radius: 8px;
    margin: 0 auto;
    padding: 20px;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 搜索区域 */
.search-section {
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.search-form {
    margin: 0;
    display: flex;
    flex-wrap: nowrap;
    align-items: end;
    gap: 10px;
}

/* 为每个表单项目设置固定宽度 */
.form-item-purchase-id {
    width: 200px;
    text-align: left;
}

.form-item-status {
    width: 150px;
    text-align: left;
}

.form-item-title {
    width: 300px;
    text-align: left;
}

.form-item-date {
    width: 180px;
    text-align: left;
}

/* 确保输入框和选择器占满表单项目宽度 */
.search-form .el-input,
.search-form .el-select,
.search-form .el-date-editor {
    width: 100%;
}

/* 订单状态标签 */
.status-tabs {
    margin-bottom: 20px;
    overflow-x: auto;
}

.status-radio-group {
    display: flex;
    align-items: center;
    white-space: nowrap;
}

::v-deep .el-radio-button__original-radio:checked+.el-radio-button__inner {
    background-color: #286CED;
    border-color: #286CED;
}

/* 表格自定义样式 */
.purchase-table {
    border-radius: 8px;
    overflow: hidden;
}

/* 状态样式 */
.status-comparison {
    color: #286CED;
}

.status-loading {
    color: #ff9800;
}

.status-pending-shipment {
    color: #4caf50;
}

.status-pending-receipt {
    color: #8bc34a;
}

.status-pending-settlement {
    color: #9c27b0;
}

.status-completed {
    color: #009688;
}

.status-cancelled {
    color: #9e9e9e;
}

/* 操作按钮样式 */
.action-buttons {
    display: flex;
    /* flex-direction: column; */
    gap: 8px;
    align-items: center;
}

/* 按钮样式 */
.text-btn {
    font-size: 12px;
    color: #BFBFBF;
    padding: 6px 12px;
    border: 1px solid #BFBFBF;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}

/* 响应式设计 */
@media (max-width: 768px) {
    .search-form {
        flex-wrap: wrap;
    }

    .form-item-purchase-id,
    .form-item-status,
    .form-item-title {
        width: 100%;
    }

    .action-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
    }
}
</style>